import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { LayoutStyleTypes } from "@/util-react/layout";
import { useProductRangeCommon } from "@/pages-react/product-range-page/ProductRangeCommon";

export const ProductRangeDesktop = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useProductRangeCommon(props.content);

  return <>{renderContent()}</>;
}, LayoutStyleTypes.TYPE_SM);
